// Apply code
  if (!window.neoCartPromoApplyInitialized) {
    window.neoCartPromoApplyInitialized = true;

    document.addEventListener('click', async function (event) {
      const button = event.target.closest('.neo-cart-promo__apply');
      if (!button || button.disabled) return;

      const promo = button.closest('.neo-cart-promo');
      const input = promo?.querySelector('.neo-cart-promo__input');
      const code = input?.value.trim();

      if (!code) return;

      button.disabled = true;
      button.textContent = 'Applying...';

      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: code
          })
        });

        if (!response.ok) {
          throw new Error('Discount request failed');
        }

        const cart = await response.json();

        const applied = (cart.discount_codes || []).some(
          (discount) =>
            discount.code.toLowerCase() === code.toLowerCase() &&
            discount.applicable
        );

        if (!applied) {
          alert('This promo code cannot be applied.');
          return;
        }

        window.location.reload();

      } catch (error) {
        console.error('Cart promo apply error:', error);
        alert('Unable to apply the promo code. Please try again.');
      } finally {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = 'Apply';
        }
      }
    });
  }


// Remove code
  if (!window.neoCartPromoRemoveInitialized) {
    window.neoCartPromoRemoveInitialized = true;

    document.addEventListener('click', async function (event) {
      const button = event.target.closest('.neo-cart-promo__remove');

      if (!button || button.disabled) return;

      button.disabled = true;
      button.textContent = 'Removing...';

      try {
        const root = window.Shopify?.routes?.root || '/';

        const cartResponse = await fetch(root + 'cart.js');

        if (!cartResponse.ok) {
          throw new Error('Could not load cart');
        }

        const cart = await cartResponse.json();
        const codeToRemove = button.dataset.code.toLowerCase();

        const remainingCodes = (cart.discount_codes || [])
          .filter(
            (discount) =>
              discount.code.toLowerCase() !== codeToRemove
          )
          .map((discount) => discount.code);

        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: remainingCodes.join(',')
          })
        });

        if (!response.ok) {
          throw new Error('Could not remove discount code');
        }

        const updatedCart = await response.json();

        const stillApplied = (updatedCart.discount_codes || []).some(
          (discount) =>
            discount.code.toLowerCase() === codeToRemove
        );

        if (stillApplied) {
          throw new Error('Discount code was not removed');
        }

        window.location.reload();

      } catch (error) {
        console.error('Cart promo remove error:', error);
        alert('Unable to remove the promo code. Please try again.');

        if (button.isConnected) {
          button.disabled = false;
          button.textContent = 'Remove';
        }
      }
    });
  }

// 갱신

/* Cart page - Refresh promo code after quantity changes */
if (!window.neoCartPagePromoRefreshInitialized) {
  window.neoCartPagePromoRefreshInitialized = true;

  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {

    if (event.source !== 'cart-items') return;

    const currentPromo = document.querySelector(
      '#main-cart-footer .neo-cart-promo-block'
    );

    if (!currentPromo) return;

    try {
      const sectionId = document.getElementById(
        'main-cart-footer'
      )?.dataset.id;

      if (!sectionId) return;

      const response = await fetch(
        `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`
      );

      if (!response.ok) {
        throw new Error('Promo section refresh failed');
      }

      const html = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const updatedPromo = html.querySelector(
        '#main-cart-footer .neo-cart-promo-block'
      );

      if (!updatedPromo) return;

      const currentAccordion = currentPromo.querySelector(
        '.neo-cart-promo'
      );

      const wasOpen = currentAccordion?.open ?? false;

      currentPromo.innerHTML = updatedPromo.innerHTML;

      const newAccordion = currentPromo.querySelector(
        '.neo-cart-promo'
      );

      if (newAccordion) {
        newAccordion.open = wasOpen;
      }

    } catch (error) {
      console.error('Promo code refresh error:', error);
    }
  });
}
